import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAuthyComponent } from './simple-icons-authy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAuthyComponent ],
    exports:      [ SimpleIconsAuthyComponent ],
    bootstrap:    []
})
export class SimpleIconsAuthyModule {}
